module.exports = __webpack_public_path__ + "media/images/flags/pt-8de166591d0cbb7c34334e764259b617.svg";